<template>
  <div class="empty-wrap">
    <div class="empty-box">
      <img
        src="@/assets/casesearchImg/EmptyData.png"
        class="empty-icon"
        alt=""
      />
      <div class="empty-title">暂无数据</div>
      <div class="empty-desc">当前筛选条件下没有找到匹配结果，请调整关键词后重试。</div>
    </div>
  </div>
</template>

<script setup>
// 无业务逻辑
</script>

<style scoped lang="less">
.empty-wrap {
  margin-top: 88px;
  width: 100%;
  height: 80%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f7f9fe;
}
.empty-box {
  width: 70%;
  padding: 60px 20px;
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e8edf5;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.empty-icon {
  width: 64px;
  height: 64px;
//   border: 1px dashed #c0c8d8;
//   border-radius: 4px;
  position: relative;
  &::after {
    content: "";
    position: absolute;
    top: 12px;
    left: 14px;
    width: 20px;
    height: 26px;
    // border: 1px solid #c0c8d8;
  }
}
.empty-title {
    font-weight: 600;
    font-size: 17px;
    color: #44546E;
    line-height: 24px;
}
.empty-desc {
    font-weight: 400;
    font-size: 16px;
    color: #7F8CA2;
    line-height: 22px;
}
</style>